import { FormikProps } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NormalDatepicker } from 'src/components/mui-overrides/Datepicker';
import { object, string } from 'yup';

const calculateExecutionDate = () => {
  // if date is < 15th of month, execution date is 15th of month
  // if date is > 15th of month, execution date is 15st of next month
  const today = new Date();
  if (today.getDate() < 15) {
    const executionDate = new Date(today.getFullYear(), today.getMonth(), 15, 12);
    return executionDate.toISOString();
  } else {
    const executionDate = new Date(today.getFullYear(), today.getMonth() + 1, 15, 12);
    return executionDate.toISOString();
  }
};

const currentDate = new Date();
const ts = currentDate.setDate(currentDate.getDate() - 1);

export const validationSchemaExecutionDate = object({
  executionDate: string()
    .required('Execution date is required')
    .test('is-past', 'Execution date must be today or in the future', (value) => {
      if (value) {
        const d = Date.parse(value);
        return d >= ts;
      }
      return false;
    }),
});

export const getInitValuesExecutionDate = () => {
  return {
    executionDate: calculateExecutionDate(),
  };
};

export interface ExecutionDateValues {
  executionDate: string;
}

interface Props {
  formik: FormikProps<ExecutionDateValues>;
}

export const ExecutionDate: FC<Props> = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={formik.handleSubmit}>
      <NormalDatepicker label={t('issuer.rent.executionDate')} fieldName="executionDate" formik={formik} minDate={currentDate} />
    </form>
  );
};
